import React from "react";
import PropTypes from "prop-types";
import { ExternalIcon } from "../icons";

const ExternalLink = ({ parentClassName, url, text }) => {
  return (
    <a
      className={`${parentClassName}__link`}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {text || "View"}
      <ExternalIcon className={`${parentClassName}__arrow`} />
    </a>
  );
};

ExternalLink.propTypes = {
  parentClassName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  text: PropTypes.string,
};

export default ExternalLink;
